export function supportsTouch(): boolean {
  return ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && !!window.TouchEvent;
}
